import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LandingPageRoutingModule } from './landing-page-routing.module';
import { LandingPageComponent } from './landing-page.component';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderModule } from './components/header/header.module';
import { FooterModule } from './components/footer/footer.module';
import { ContactFormModule } from './components/contact-form/contact-form.module';
import { SystemButtonModule } from '@app/shared/ui-components';

@NgModule({
  declarations: [LandingPageComponent],
  imports: [
    CommonModule,
    LandingPageRoutingModule,
    HeaderModule,
    FooterModule,
    ContactFormModule,
    TranslateModule,
    SystemButtonModule,
  ],
})
export class LandingPageModule {}
